export class DropdownValue {
    constructor(public value: number, public label: string) {
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/dropdown.model.ts